



































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import Editor from '@/components/Editor/editor.vue'
import { getNewsDetail, editNews, addEditTags } from '@/api/content/content-news/news'

const classifyList = [
  {
    id: 1,
    name: '热门资源'
  },
  {
    id: 2,
    name: '新游资讯'
  },
  {
    id: 3,
    name: '游戏攻略'
  }
]
const langList = [
  {
    id: 0,
    name: '英文',
    lang: 'en_US',
    content: '',
    title: ''
  },
  {
    id: 1,
    name: '中文(简体)',
    lang: 'zh_CN',
    content: '',
    title: ''
  },
  {
    id: 2,
    name: '中文(繁体)',
    lang: 'zh_TW',
    content: '',
    title: ''
  }
]

@Component({
  name: 'NewsEdit',
  components: {
    Editor
  }
})
export default class extends mixins(DisplayMixin) {
  params: any = {
    id: 0,
    seq: 0,
    name_zh: '',
    name_en: ''
  }
  classifyList = classifyList
  langList = langList
  activeIndex = 0
  currentLang: string = 'en_US'

  created() {
    const query = this.$route.query
    // ~~query.id && this.getDetail(query.id as string)
    if (+query.id) {
      this.params.id = +query.id
      this.params.seq = +query.seq || 0
      this.params.name_zh = query.name_zh
      this.params.name_en = query.name_en
    }
  }

  async getDetail(id: string) {
    const res: any = await getNewsDetail({ id })
    const d: any = res.data
    !d.contentList.length && (d.contentList = this.params.contentList)
    const map: any = { contentList: 'contentList', poster: 'coverURL', classifyId: 'cid', appId: 'relateAppID', sort: 'seq', publishDate: 'publishedDate', platform: 'platform', url: 'moreURL', langList: 'contentList' }
    this.params.id = id
    this.updateParams(map, d)
  }

  updateParams(map: any, data: any) {
    for (const item in map) this.params[item] = data[map[item]]
  }

  formatParams(map: any) {
    let obj: any = { ...this.params }
    for (const item in map) {
      obj[map[item]] = this.params[item]
      delete obj[item]
    }
    return obj
  }

  handleSwitch(i:number) {
    this.activeIndex = i
  }

  handleSwitchLanguage(lang: string, index: number) {
    this.currentLang = lang
    this.activeIndex = index
    console.log(this.activeIndex)
  }

  checkParams() {
    if (!this.params.name_zh) return this['$message'].warning('请输入分类中文名称')
    if (!this.params.name_en) return this['$message'].warning('请输入分类英文名称')
  }
  async handeSubmit(type: 'save' | 'commit') {
    if (this.checkParams()) return false
    this.params.seq = +this.params.seq || 0
    const res: any = await addEditTags(this.params)
    ~~res.status.code === 0 && this.$router.push('/content/content-news/news-tags')
    // location.reload()
    // this.$route.query.id && await this.getDetail(this.$route.query.id as string)
  }

  get plat() {
    return this.$route.query.platform
  }
}
